import React, { Component } from 'react';
import { number, oneOfType, string } from 'prop-types';
import './HeaderData.scss';

class HeaderData extends Component {
  static propTypes = {
    className: string,
    label: string,
    value: oneOfType([number, string])
  };

  static defaultProps = {
    className: 'pxl-text-small'
  };

  render() {
    const { className, label, value } = this.props;
    return (
      <div className={`data__section ${className}`}>
        {label}
        <span className="data__item">{value}</span>
      </div>
    );
  }
}

export default HeaderData;
